import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { getUsers } from '../../services/api';
import '../restaurants/AdminRestaurants.css';

const ROLES = { 1: 'Admin', 2: 'Manager', 3: 'Waiter', 4: 'Bartender', 5: 'Cook' };

const AdminUsers = () => {
  const { authenticatedFetch } = useAuth();
  const [users, setUsers] = useState(null);
  const [error, setError] = useState('');
  const [query, setQuery] = useState('');

  const fetchData = useCallback(async () => {
    setUsers(null);
    setError('');
    try {
      setUsers(await getUsers(authenticatedFetch));
    } catch (err) {
      setError(err.message);
    }
  }, [authenticatedFetch]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const filtered = useMemo(() => {
    if (!users) return [];
    const q = query.trim().toLowerCase();
    const sorted = [...users].sort((a, b) => a.email.localeCompare(b.email));
    return q
      ? sorted.filter((u) => [
        u.username,
        u.email,
        ROLES[u.role],
        u.is_super_admin ? 'super admin' : '',
      ].join(' ').toLowerCase().includes(q))
      : sorted;
  }, [users, query]);

  return (
    <div className="admin-restaurants">
      <header className="admin-page-header">
        <div>
          <h1>Users</h1>
          {users && <p className="admin-page-count">{users.length} total</p>}
        </div>
        <input
          type="search"
          className="admin-search"
          placeholder="Search by name, email or role"
          aria-label="Search users"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </header>

      {error && (
        <div className="admin-state admin-state-error" role="alert">
          <p>{error}</p>
          <button type="button" className="admin-retry" onClick={fetchData}>Try again</button>
        </div>
      )}

      {!error && !users && <div className="admin-state">Loading…</div>}

      {users && !error && (
        filtered.length === 0 ? (
          <div className="admin-state">{query ? 'No users match your search.' : 'No users yet.'}</div>
        ) : (
          <div className="admin-table-card">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((u) => (
                  <tr key={u.id}>
                    <td className="admin-cell-name ph-no-capture">{u.username}</td>
                    <td className="ph-no-capture">{u.email}</td>
                    <td>
                      {ROLES[u.role] || '—'}
                      {u.is_super_admin && <span className="admin-badge is-super">Super admin</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
};

export default AdminUsers;
